module.exports = __webpack_public_path__ + "static/media/AUROPHARMA.67b08125.txt";